// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as AuthStore$PorterinFeature from "../store/AuthStore.mjs";
import * as CustomerProfileApiModel$PorterinFeature from "../api-model/CustomerProfileApiModel.mjs";

function apiModelToState(model) {
  var isVerified = Belt_Option.getWithDefault(model.mail_info.is_verified, false);
  return {
          mobile: model.mobile,
          mail_info: {
            is_verified: isVerified,
            email: Belt_Option.getWithDefault(model.mail_info.email, "N.A.")
          },
          customer_uuid: model.external_id,
          last_name: Belt_Option.getWithDefault(model.last_name, ""),
          first_name: Belt_Option.getWithDefault(model.first_name, AuthStore$PorterinFeature.Profile.default_name)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(CustomerProfileApiModel$PorterinFeature.t_decode(json), "CustomerProfileEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
